/**
 * Compact "how long ago" label for insight freshness, e.g. `4m`, `3h`, `2d`.
 * Falls back to an empty string on an unparseable timestamp so callers can
 * simply omit the element.
 */
export const relativeTime = (iso: string): string => {
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return '';

  const seconds = Math.max(0, Math.round((Date.now() - then) / 1000));
  if (seconds < 60) return 'just now';

  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m`;

  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h`;

  const days = Math.round(hours / 24);
  if (days < 7) return `${days}d`;

  const weeks = Math.round(days / 7);
  if (weeks < 5) return `${weeks}w`;

  return new Date(then).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

/** Full timestamp for the `title`/tooltip behind the compact label. */
export const absoluteTime = (iso: string): string => {
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return '';
  return new Date(then).toLocaleString();
};
